export default "__VITE_ASSET__Dkj$3ND1__"